export function useUrlSearchParams() {
  function setUrlParam(param: string, value: string) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    if (params.has(param)) {
      params.set(param, value);
    } else {
      params.append(param, value);
    }

    window.history.replaceState({}, '', currentUrl.toString());
  }

  function removeUrlParam(param: string) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    if (params.has(param)) {
      params.delete(param);
    }

    window.history.replaceState({}, '', currentUrl.toString());
  }

  function getUrlParam(param: string) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    return params.get(param);
  }

  return {
    setUrlParam,
    removeUrlParam,
    getUrlParam,
  };
}
